import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    IDLE, PENDING,
    LIST, ADD, EDIT,
} from "const"
import { MtStudy } from "server/models"
import { StateType, deepCopy, hasProjectAccess } from "client/utils"
import {
    PRM_STUDY,
    StoreType,
    StudyList,
    StudyFilters,

    LoadAllStudies,
    DeleteStudy,
    SortStudies,

    setStudyList,
    setStudyIds,
    setStudySort,
    setStudyFilters,
    addModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
    Button,
    Table,
    TableSearchWrapper,
    SortRows,
    DeleteRow,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import StudySearch from "client/pages/search/studySearch"
import Columns from "./columns"


const List = () => {
    const baseRoute = useSelector((state: StoreType) => state.study.baseRoute)
    const studyList = useSelector((state: StoreType) => state.study.studyList)
    const studyIds = useSelector((state: StoreType) => state.study.studyIds)
    const sortColumn = useSelector((state: StoreType) => state.study.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.study.sortOrder)
    const filters = useSelector((state: StoreType) => state.study.filters)
    const reloadList = useSelector((state: StoreType) => state.study.reloadList)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        LoadAllStudies(project.id).then((res) => {
            dispatch(setStudyList(res))
            setLoadState(IDLE)
        })
    }, [reloadList])

    useEffect(() => {
        const sortedIds = SortStudies(Object.values(studyList), sortColumn, sortOrder, filters)
        dispatch(setStudyIds(sortedIds))
    }, [studyList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MtStudy, order) => {
        dispatch(setStudySort(column, order))
    }

    const onFilter = (newFilters: StudyFilters) => {
        dispatch(setStudyFilters(newFilters))
    }

    const onDelete: DeleteRow = (study: MtStudy, callback) => {
        DeleteStudy(study.id, project.id).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const studyListCopy: StudyList = studyList ? deepCopy(studyList) : {}
                delete studyListCopy[study.id]
                dispatch(setStudyList(studyListCopy))
                dispatch(setStudyIds(studyIds.filter((id) => id !== study.id)))
            })
        })
    }

    const columns = Columns()

    const listAccess = hasProjectAccess(PRM_STUDY, LIST)
    const addAccess = hasProjectAccess(PRM_STUDY, ADD)

    if (!listAccess) return <AccessDenied />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.studies}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <TableSearchWrapper>
                    <StudySearch
                        id="studyList"
                        rightOffset={addAccess}
                        filters={filters}
                        onFilter={onFilter}
                    />
                    {
                        addAccess && (
                            <Button
                                variant="success"
                                onClick={() => dispatch(addModal({
                                    url: `${baseRoute}/${EDIT}/0`,
                                }))}
                            >
                                {lang.add}
                            </Button>
                        )
                    }
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={studyList}
                    dataIds={studyIds}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="md"
                    showPagination
                    onSort={onSort}
                    onDelete={onDelete}
                />
            </PageContent>
        </Container>
    )
}
export default List
